import { TBody, Td, Tr } from 'app/components/Table';
import { Skeleton } from '@chakra-ui/react';
import { TEST_ID_LOADING_INDICATOR } from 'app/utils/test/constants';
import { getSkeletonSx } from './styles';

interface LoadingRowProps {
  columns: Array<{
    accessorKey: string;
    isAvatar?: boolean;
    isOptions?: boolean;
  }>;
  repeat?: number;
}

export const LoadingBody = ({ columns, repeat = 3 }: LoadingRowProps) => {
  return (
    <TBody data-testid={TEST_ID_LOADING_INDICATOR}>
      {Array.from({
        length: repeat,
      }).map((_, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <Tr key={i}>
          {columns.map((column, index) => {
            const hasAccesory = ['avatar', 'controls', 'accessory'].includes(
              columns[0].accessorKey
            );
            const tdSx = hasAccesory && index === 1 ? { pl: 0 } : {};
            const skeletonSx = getSkeletonSx(column);
            return (
              <Td key={column.accessorKey} isAvatar={column.isAvatar} sx={tdSx}>
                <Skeleton sx={skeletonSx} />
              </Td>
            );
          })}
        </Tr>
      ))}
    </TBody>
  );
};
